const ToggleButton = theme => ({
    groupedHorizontal: {
        '&:not(:first-child)': {
            marginLeft: 0
        }
    },
});

export default ToggleButton;
